/**
 * Angular environment
 */
import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';

/**
 * Service environment
 */
import { FunCollectionService } from '../../common/common-functions/fun-collection.service';
import { MasterserviceService } from '../../dataservices/master-service/masterservice.service';
import { PostApiService } from '../../dataservices/post-api.service';
import { GetService } from '../../dataservices/get.service';
import { JwtDecodeService } from '../../dataservices/jwt-decode.service';
import { NewLanguageService } from '../../dataservices/new-language/new-language.service';
import { ImageGroupService } from '../../dataservices/master-service/image-group.service';
import { DataStorageService } from './../../dataservices/data-storage.service';

/**
 * Constant file import.
 */
import { CME_TYPE, PRODUCT_TYPE_CONSTANT, FILTER_NAME, SCREEN_NAME, NUMBERS } from './../../constants/app.constants';
import { EVENT_NAME } from '../../analytics-event/analytics.constant';
/**
 * Interface import.
 */
import { AnalyticsInterface } from '../../analytics-event/analytics.model';

/**
 * Rxjs imports.
 */
import { Subscription } from 'rxjs';
import { Course } from 'src/app/onboarding/interface/global.model';

/**
 * Web Cme Card Component
 */
@Component({
  selector: 'app-web-cme-card',
  templateUrl: './web-cme-card.component.html',
  styleUrls: ['./web-cme-card.component.scss']
})
export class WebCmeCardComponent implements OnInit, OnDestroy {
  @Input() callingfrom;
  /**
   * cme object data
   */
  @Input() cmeObj !: Course;
  @Input() cmeIdx;

  public feed_bookmark_loader = false;
  public cme_bookmark_loader = false;
  public mediaObj = [];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public certificateType: any;
  public mediaModal = false;
  public openMediaIndex = 0;
  public screen_name = 'generate_certificate';
  public hasChanged = false;
  public subscribe_obj: object;
  public showSubscribeModal = false;

  public numbers = NUMBERS;
  public screenName = SCREEN_NAME;

  /**
   * To unsubscribe data.
   */
  private subscriptions: Subscription = new Subscription();


  /**
   * variable for product type
   */
  public pType = PRODUCT_TYPE_CONSTANT;

  /**
   * Cme Types constant.
   */
  public Cme_Type = CME_TYPE;

  /**
   * Output is used to emit specialty of card.
   */
  @Output() feedSpecialty = new EventEmitter();

  /**
   * Analytics data object.
   */
  public analyticsData: AnalyticsInterface;
  /**
   * Get specialty list as string for CT.
   */
  public speciality = '';

  /**
   * Necessary instances.
   */
  constructor(
    private masterService: MasterserviceService,
    private router: Router,
    public fcs: FunCollectionService,
    public getService: GetService,
    private postSer: PostApiService,
    private jwtSer: JwtDecodeService,
    public mls: NewLanguageService,
    public igs: ImageGroupService,
    private dss: DataStorageService
  ) { }

  /**
   * ngOnInit
   */
  ngOnInit(): void {

    if (this.cmeObj.channel != null) {
      this.subscribe_obj = {
        'target_id': this.cmeObj.channel.target_id,
        'channel_name': this.cmeObj.channel.title,
        'tnc_url': this.cmeObj.channel.tnc_url,
        'target_name': this.cmeObj.channel.powered_name,
        'target_label': this.cmeObj.channel.powered_by_label,
        'publication_logo': this.cmeObj.channel.channel_logo,
        'sponsor_footer_text': this.cmeObj.channel.sponsor_footer_text,
        'no_of_members': this.cmeObj.channel.no_of_members,
        'safe_url': this.cmeObj.channel.safe_url,
        'product_view': this.cmeObj.channel.is_product_view,
        'calling_from': 'cme_list',
        'target_id_clinical_detail': this.cmeObj.course_id

      };
    }
    /**
     * Analytics oject.
     */
    if (this.callingfrom) {
      /**
       * Get specilty list for analytics.
       */
      if (this.cmeObj.speciality.length > 0) {
        const specialityList = this.cmeObj.speciality;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const arrayColumn = (array, column): any => {
          return array.map(item => item[column]);
        };
        const specialityNames = arrayColumn(specialityList, FILTER_NAME.speciality_name);
        this.speciality = specialityNames.join(',');
      }
      this.analyticsData = {
        'event_name': EVENT_NAME.CME_CARD_CLICK,
        'product_type': this.cmeObj.product_type,
        'product_type_id': this.cmeObj.product_type_id,
        'screen_name': this.callingfrom,
        'Specialty': this.speciality
      };
    }
  }
  
  /**
   * view certificate
   */
  viewCertificate(): void {
    this.mediaModal = false;
    if (this.cmeObj.certificate_url != '' && this.cmeObj.certificate_url != undefined) {
      this.mediaModal = true;
    } else {
      this.subscriptions.add(this.postSer.generateCmeCertificate(this.cmeObj.course_id).subscribe(resData => {
        this.jwtSer.decodeData(resData).then(data => {
          if (data['status'] == 1) {
            this.cmeObj.certificate_url = data['data'].pdf_url;
            const stringToSplit = this.cmeObj.certificate_url;
            if (stringToSplit != null && stringToSplit != '') {
              const x = stringToSplit.split('.');
              this.certificateType = x[x.length - 1];
            }
            this.mediaObj = [];
            const t = {
              media_id: 1,
              media_name: 'certificate',
              media_thumbnail: '',
              media_type: 'document',
              media_url: this.cmeObj.certificate_url
            };
            this.mediaObj.push(t);
            this.mediaModal = true;
            this.hasChanged = !this.hasChanged;
          } else {
            this.fcs.errorHandeler(data, this.screen_name);
            return;
          }
        });
      }));
    }
  }

  /**
   * set Reset Media Modal
   */
  setResetMediaModal(val, indx): void {
    if (indx == undefined) {
      this.openMediaIndex = 0;
    }
    this.mediaModal = val;
    if (indx != '' && indx != undefined) { this.openMediaIndex = indx; }
  }

  /**
   * navigate To detail
   */
  navigateTodetail(id): boolean {
    if (this.masterService.isOnline == false) {
      this.masterService.isConnectionModalShown.next('1');
      return false;
    }


    if (this.cmeObj.channel == null) {

      this.masterService.url_after_leave_cme = 'cme/detail/' + id;
      this.router.navigateByUrl('cme/detail/' + id);

    } else if (this.cmeObj.channel.is_subscribed == 0 && this.cmeObj.channel.is_product_view == 0) {
      this.showSubscribeModal = true;

    } else if (this.cmeObj.channel.is_product_view == 1 || this.cmeObj.channel.is_subscribed == 1) {

      this.router.navigateByUrl('cme/detail/' + id);


    }

  }

  /**
   * Used to redirect to leader board page
   */
  navigateToLeaderBoard(): void {
    window.open(this.cmeObj.quiz_leaderboard_url, '_blank');
  }

  /**
   * product Share
   */
  productShare(): void {
    const x = [{ share_url: '', share_contentt: this.cmeObj.share_content, product_type: 8, product_type_id: this.cmeObj.course_id }];
    this.fcs.productShare(x);
  }

  /**
   * product Bookmark
   */
  productBookmark(): void {
    if (this.cme_bookmark_loader == true) { return; }
    this.cme_bookmark_loader = true;
    const action = (this.cmeObj.is_bookmarked == 0) ? 'add' : 'delete';
    this.subscriptions.add(this.postSer.productBookmark(8, this.cmeObj.course_id, action).subscribe(resData => {
      this.cme_bookmark_loader = false;
      this.jwtSer.decodeData(resData).then(data => {

        this.masterService.bookmark_index.next(this.cmeIdx);
        if (data['status'] == 1) {
          this.fcs.showSuccess(data['msg'], 'Success');
          this.cmeObj.is_bookmarked = (action == 'add') ? 1 : 0;

        } else if (data['status'] == 0) {
          this.fcs.showError(data['msg'], 'Error');
          this.fcs.errorHandeler(data);
          return;
        }
      },
      () => {
        this.cme_bookmark_loader = false;
      }
      );
    }));
  }

  /**
   * get Cme Detail
   */
  getCmeDetail(id): void {
    this.masterService.url_after_leave_cme = 'cme/detail/' + id;
    this.router.navigateByUrl('cme/detail/' + id);
  }

  /**
   * reset Subscribe Modal
   */
  resetSubscribeModal(): void {
    this.showSubscribeModal = false;
  }

  /**
   * Function is used to get specialty.
   */
  getSpecialty(speciality): void {
    this.feedSpecialty.emit(speciality);
    this.dss.specialty_filter = speciality;
    this.router.navigate(['/web/list']);
  }

  /**
   * unsubscribe the subscription.
   */
  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }
}
